import Resource from '@/api/resources/Resource'

class IdentifierRegexesService extends Resource {
    async getRegexes() {
        const response = await this.axios.get(`/common/identifierRegexes`)
        return response.data
    }
    async getClinicalRegexes() {
        const response = await this.axios.get(`/clinical/identifierRegexes`)
        return response.data
    }
}

export const PATIENT_IDENTIFIER_CODES = {
    NIF: 'identifierType.NIF',
    NHC: 'identifierType.NHC'
}

export default new IdentifierRegexesService()
